export const manscapedTitle = "MANSCAPED®";

export const skinsafeTitle = "SkinSafe®";

export const rightToolsTitle = "The Right Tools For The Job®";
export const rightToolsTitleSentence = "The right tools for the job®";
export const quietStrokeTitle = "QuietStroke®";
export const yourBallsWillThankYouTitle = "Your Balls Will Thank You®";
export const weSaveBallsTitle = "We Save Balls®";
export const ultraPremiumTitle = "UltraPremium";

export const lawnMowerTitle = "Lawn Mower®";
export const theLawnMowerTitle = "The Lawn Mower®";
export const theLawnMower2Title = "The Lawn Mower® 2.0";
export const theLawnMower3Title = "The Lawn Mower® 3.0";
export const theLawnMower4Title = "The Lawn Mower® 4.0";
export const theLawnMower5Title = "The Lawn Mower® 5.0";

export const weedWhackerTitle = "Weed Whacker®";
export const weedWhacker2Title = "Weed Whacker® 2.0";

export const theBeardHedgerTitle = "The Beard Hedger®";

export const cropCleanserTitle = "Crop Cleanser®";
export const cropMopTitle = "Crop Mop®";
export const cropPreserverTitle = "Crop Preserver®";
export const cropReviverTitle = "Crop Reviver®";
export const cropSootherTitle = "Crop Soother™";

export const cropExfoliatorTitle = "Crop Exfoliator®";
export const cropGelTitle = "Crop Gel®";
export const theCropShaverTitle = "The Crop Shaver®";

export const thePlowTitle = "The Plow®";
export const thePlow2Title = "The Plow® 2.0";

export const footDusterTitle = "Foot Duster®";

export const magicMatTitle = "Magic Mat®";

export const theHandymanTitle = "The Handyman™";

export const theDomeShaverProTitle = "The Dome Shaver™ Pro";

export const theDomeShaverPlusTitle = "The Dome Shaver™ Plus";

export const theChairmanProTitle = "The Chairman™ Pro";

export const theChairmanPlusTitle = "The Chairman™ Plus";

export const refinedTitle = "Refined®";
export const persevereTitle = "Persevere®";

export const testicularCancerSocietyTitle = "Testicular Cancer Society®";

export const theJewelPouch = "The Jewel Pouch®";

export const phpDevicesList = `${theLawnMowerTitle}, ${weedWhackerTitle} trimmer, ${theBeardHedgerTitle}, ${theHandymanTitle}, ${theDomeShaverProTitle}, ${theDomeShaverPlusTitle}, ${theChairmanProTitle}, and/or ${theChairmanPlusTitle}`;
